import { render, staticRenderFns } from "./lianmaiRecord.vue.js?vue&type=template&id=5b54333f&scoped=true!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./lianmaiRecord.vue?vue&type=template&id=5b54333f&scoped=true"
import script from "./lianmaiRecord.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./lianmaiRecord.vue?vue&type=script&lang=js"
export * from "./lianmaiRecord.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./lianmaiRecord.vue?vue&type=script&lang=js"
import style0 from "./lianmaiRecord.vue.scss?vue&type=style&index=0&id=5b54333f&lang=scss&scoped=true!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./lianmaiRecord.vue?vue&type=style&index=0&id=5b54333f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b54333f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/web-hok_Mssh/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b54333f')) {
      api.createRecord('5b54333f', component.options)
    } else {
      api.reload('5b54333f', component.options)
    }
    module.hot.accept("./lianmaiRecord.vue.js?vue&type=template&id=5b54333f&scoped=true!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./lianmaiRecord.vue?vue&type=template&id=5b54333f&scoped=true", function () {
      api.rerender('5b54333f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/live/liveRoom/components/Dialog/lianmaiRecord.vue"
export default component.exports